import {
  RESET_CLIENT_INFO,
  CLIENT_INFO_ERROR,
  GET_CLIENT_INFO,
  SET_CLIENT_INFO,
  SET_CURRENT_CHAT_DATA,
} from "./actionTypes";

const initialState = {
  currentChatId: "",
  currentConsumerId: "",
  currentConversationTabId: "",
  data: {},
  info: {},
  status: {},
};

const ClientInformation = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_INFO_ERROR:
      state = {
        ...state,
        status: {
          ...state.status,
          [action.payload.action]: {
            error: {
              status: true,
              message: action.payload.message,
            },
            loading: false,
            success: false,
          },
        },
      };
      break;
    case RESET_CLIENT_INFO:
      state = {
        ...state,
        info: {
          ...(state.info ? state.info : null),
          [action.payload]: null,
        },
      };
      break;
    case GET_CLIENT_INFO:
      state = {
        ...state,
        data: action.payload,
        status: {
          ...state.status,
          get_info: {
            error: false,
            loading: true,
            success: false,
          },
        },
      };
      break;
    case SET_CLIENT_INFO:
      state = {
        ...state,
        data: null,
        info: {
          ...(state.info ? state.info : null),
          [action.payload.chatId]: action.payload.data,
        },
        status: {
          ...state.status,
          get_info: {
            error: false,
            loading: false,
            success: true,
          },
        },
      };
      break;
    case SET_CURRENT_CHAT_DATA:
      state = {
        ...state,
        currentConversationId: action?.payload?.conversationId,
        currentTabId: action?.payload?.tabId,
        currentConsumerId: action?.payload?.consumerId,
      };
      break;
    default:
      // do nothing
      break;
  }
  return state;
};

export default ClientInformation;
